import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { ObjectComponent } from '@sizzlenz/shared';
import { ObjectComponentItem } from './ObjectComponentItem';
import { Package } from 'lucide-react';
type ComponentFilter = 'all' | 'open-provider';
interface ObjectComponentsSummaryProps {
  components: ObjectComponent[];
  /** Which components to display. Defaults to 'all'. */
  filter?: ComponentFilter;
  /** Section title. Defaults to 'Components'. */
  title?: string;
  /** Hide the section entirely when no components match the filter. Defaults to true. */
  hideWhenEmpty?: boolean;
  /** Show full details without truncation. */
  expanded?: boolean;
  /** When true, only show components with marketplaceVisibility = 'public'. Defaults to false. */
  publicOnly?: boolean;
}
function filterComponents(components: ObjectComponent[], filter: ComponentFilter): ObjectComponent[] {
  switch (filter) {
    case 'open-provider':
      return components.filter(c => c.needsProvider && c.status === 'open');
    case 'all':
    default:
      return components;
  }
}
export function ObjectComponentsSummary(t0) {
  const $ = _c(13);
  const {
    components,
    filter: t1,
    title: t2,
    hideWhenEmpty: t3,
    expanded,
    publicOnly: t4
  } = t0;
  const filter = t1 === undefined ? "all" : t1;
  const title = t2 === undefined ? "Components" : t2;
  const hideWhenEmpty = t3 === undefined ? true : t3;
  const publicOnly = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== components || $[1] !== filter || $[2] !== publicOnly) {
    const byFilter = filterComponents(components, filter);
    t5 = publicOnly ? byFilter.filter(_temp) : byFilter;
    $[0] = components;
    $[1] = filter;
    $[2] = publicOnly;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const filtered = t5;
  if (hideWhenEmpty && filtered.length === 0) {
    return null;
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Package className="w-4 h-4" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== title) {
    t7 = <h3 className="text-sm font-bold text-indigo-800 uppercase tracking-wider flex items-center gap-2">{t6}{title}</h3>;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== expanded || $[8] !== filtered) {
    t8 = filtered.length === 0 ? <p className="text-sm text-muted-foreground">No components to display.</p> : <div className="space-y-2">{filtered.map(component => <ObjectComponentItem key={component.id} component={component} expanded={expanded} />)}</div>;
    $[7] = expanded;
    $[8] = filtered;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <section className="rounded-xl border-2 border-indigo-200 bg-indigo-50/60 p-4 space-y-3">{t7}{t8}</section>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}
function _temp(c) {
  return c.marketplaceVisibility === "public";
}